import { useSidebarNavMatchRoute } from 'components/hooks/useSidebarNavMatchRoute';
import { useDispatch } from 'react-redux';
import {
  setIsSaveViewModalOpen,
  useIsSaveViewModalOpen,
  useViewsQuery,
  useCheckedEmployees,
  useIsViewStatic,
  useViewVisibility,
  useViewName,
  VIEWS_ACTIONS,
} from 'reducers/viewsSlice';

import { Info } from 'assets/assetsV1/iconComponents/Info';

import { VIEWS_DYNAMIC_TYPES_VALUES, VIEWS_FILTER_KEYS } from 'constants/ProjectConstants';
import { sendCreatedCustomTeamEvent } from 'constants/mixpanelHelper';
import { sendApplyAndSaveEvent } from 'constants/mixpanelHelpers/viewsEvents';

import { ConfirmationModal } from 'uiToolkitV1/ConfirmationModal';

import { useSaveView } from '../Hooks/dataHooks';
import { useViewPageName } from '../Hooks/useViewPageName';

const TitleComponent = () => (
  <>
    <Info boxSize="32px" />
    <span style={{ marginLeft: '4px' }}>Confirmation</span>
  </>
);

export const SaveViewModal = () => {
  const isSaveViewModalOpen = useIsSaveViewModalOpen();
  const { isLoading, mutate: saveView } = useSaveView();
  const dispatch = useDispatch();
  const { module } = useSidebarNavMatchRoute();

  const query = useViewsQuery();
  const cohortEmployees = useCheckedEmployees();
  const isStatic = useIsViewStatic();
  const viewType =
    cohortEmployees?.length > 0
      ? VIEWS_DYNAMIC_TYPES_VALUES.STATIC
      : isStatic === 0
        ? VIEWS_DYNAMIC_TYPES_VALUES.DYNAMIC
        : VIEWS_DYNAMIC_TYPES_VALUES.STATIC;
  const viewSharing = useViewVisibility();
  const viewName = useViewName();
  const page = useViewPageName();

  const filtersSelected = [
    ...Object.keys(query ?? {}),
    ...(cohortEmployees?.length > 0 ? [VIEWS_FILTER_KEYS.EMPLOYEES] : []),
  ];

  const onClickWithEvent = () => {
    saveView();
    sendApplyAndSaveEvent({
      eventProperties: {
        page,
        filtersSelected,
        source: module,
        operationType: VIEWS_ACTIONS.CREATE,
        viewType,
        viewSharing,
        viewName,
      },
    });

    sendCreatedCustomTeamEvent({
      eventProperties: {
        attributesChosen: filtersSelected,
      },
    });
  };

  return (
    <ConfirmationModal
      isCentered
      isOpen={isSaveViewModalOpen}
      onClose={() => dispatch(setIsSaveViewModalOpen(false))}
      title={<TitleComponent />}
      body="This view will be saved with the selected user filters and will be available across different modules"
      cancelText="Cancel"
      onCancel={() => dispatch(setIsSaveViewModalOpen(false))}
      continueText="Okay"
      onContinue={() => onClickWithEvent()}
      disabled={isLoading}
    />
  );
};
